import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Stack } from '@yonderland/andes-react';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { makeGetExpertReviews } from '../../redux/product/selectors/ProductSelector';
import { ExpertReview } from './ExpertReview';
export const ExpertReviews = () => {
    const expertReviews = useSelector(makeGetExpertReviews());
    return (_jsx(Stack, { direction: "col", gap: "8", children: expertReviews.map((review, index) => (_jsxs(Fragment, { children: [index > 0 && _jsx(Divider, {}), _jsx(ExpertReview, { expertReview: review }, review.id)] }, review.id))) }));
};
